export default "__VITE_ASSET__C9bIb5Jv__"